import { Box, Icon, ToastNotification, Typography } from "@drone-js/core";
import { usePropertySelectionViewModelValue } from "apps/propertySelection/propertySelectionViewModelAtom";
import { memo } from "react";

export const UnexpectedErrorToast = memo(() => {
    const {
        inputUrlCms: { toastErrorTitle, toastErrorContent },
    } = usePropertySelectionViewModelValue();

    return (
        <Box position="fixed" maxWidth="288px" right="24px" bottom="102px" zIndex={999}>
            <ToastNotification
                intent="error"
                title={
                    <Box display="flex" alignItems="center">
                        <Icon id="fill.symbol.triangle-exclamation" me="8" size="20" color="feedback.negative" />
                        <Typography variant="body-s-strong">{toastErrorTitle}</Typography>
                    </Box>
                }
                description={
                    <Box ms="4">
                        <Typography variant="body-s" ms="24">
                            {toastErrorContent}
                        </Typography>
                    </Box>
                }
                dismissible
            />
        </Box>
    );
});
